var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEditIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16.015 3.104-1.817 1.817 4.88 4.88 1.817-1.817a2.402 2.402 0 0 0 0-3.397l-1.479-1.483a2.402 2.402 0 0 0-3.397 0zM13.35 5.77 4.6 14.523c-.39.39-.676.875-.833 1.404l-1.33 4.516a.901.901 0 0 0 1.116 1.122l4.515-1.329a3.33 3.33 0 0 0 1.404-.833l8.758-8.754-4.88-4.88Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEditIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/edit-icon.be22bb50b91133f52df46cc57cae580f.svg";